import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
}

export function formatDate(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function getCashbackRate(category: string): number {
  const rates: Record<string, number> = {
    pharmaceuticals: 3.0, supplies: 2.5, equipment: 2.0,
    lab: 2.0, food: 1.5, services: 1.0, other: 1.0,
  };
  return rates[category.toLowerCase()] ?? 1.0;
}
